import { useRef, useState } from "react";
import { CommerceDialog } from "./CommerceDialog";
import { itemDoCatalogo } from "../../utils/itemDoCatalogo";
import { OrcamentoBotao } from "../calculadora/OrcamentoUI";
const moeda = valor => Number(valor || 0).toLocaleString("pt-BR", {style:"currency", currency:"BRL"});
const normalizar = valor => String(valor || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export function CatalogoOrcamento({ produtos, cliente, onClose, onAdicionar }) {
  const [busca, setBusca] = useState("");
  const [selecionado, setSelecionado] = useState(null);
  const [quantidade, setQuantidade] = useState("1");
  const [preco, setPreco] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const busyRef = useRef(false);
  const encontrados = produtos.filter(p => normalizar(p.nome).includes(normalizar(busca)));
  let item;
  try { item = itemDoCatalogo(selecionado, quantidade, preco); } catch {}
  async function adicionar() {
    if (!item || busyRef.current) return;
    busyRef.current = true; setSalvando(true); setErro("");
    try { await onAdicionar(item); onClose(); }
    catch (e) { setErro(e.message || "Não foi possível adicionar o produto. Tente novamente."); }
    finally { busyRef.current = false; setSalvando(false); }
  }
  return <CommerceDialog className="budget-modal budget-catalog-modal" title="Adicionar produto ao carrinho" subtitle={`Orçamento de ${cliente}`} onClose={() => { if (!busyRef.current) onClose(); }} footer={<>
    <span className="commerce-secondary" aria-live="polite">Subtotal: <strong>{moeda(item ? item.preco * item.quantidade : 0)}</strong></span>
    <OrcamentoBotao small outline onClick={onClose} disabled={salvando}>Cancelar</OrcamentoBotao>
    <OrcamentoBotao color="#00a989" disabled={!item || salvando} onClick={adicionar}>{salvando ? "Adicionando…" : "Adicionar ao carrinho"}</OrcamentoBotao>
  </>}>
    <div className="commerce-stack">
      <input className="catalog-search" type="search" aria-label="Buscar produto no catálogo" placeholder="Buscar produto pelo nome…" value={busca} onChange={e => setBusca(e.target.value)} disabled={salvando} />
      <div className="catalog-list" aria-label="Produtos do catálogo">
        {encontrados.map(p => {
          const foto = p.fotos?.find(f => f.tipo !== "video")?.url || p.fotoBase64;
          return <button className="catalog-option" key={p.id} aria-pressed={selecionado?.id === p.id} disabled={salvando} onClick={() => { setSelecionado(p); setPreco(p.preco == null ? "" : String(p.preco)); setErro(""); }}>
            {foto ? <img src={foto} alt="" /> : <span className="catalog-placeholder" />}
            <span>{p.nome}<small>{Math.max(0, parseInt(p.estoque) || 0)} em estoque</small></span>
            <strong>{p.preco == null ? "Sem preço" : moeda(p.preco)}</strong>
          </button>;
        })}
        {!encontrados.length && <p className="commerce-hint">{produtos.length ? "Nenhum produto encontrado para essa busca." : "Seu catálogo ainda está vazio. Cadastre um produto para adicioná-lo aqui."}</p>}
      </div>
      {selecionado && <section className="commerce-section">
        <h3>{selecionado.nome}</h3>
        <div className="catalog-fields">
          <label>Quantidade<input type="number" min="1" step="1" value={quantidade} disabled={salvando} onChange={e => setQuantidade(e.target.value)} /></label>
          <label>Preço unitário (R$)<input type="number" min="0" step="0.01" value={preco} disabled={salvando} onChange={e => setPreco(e.target.value)} /></label>
        </div>
        {!item && <p className="commerce-hint">Informe uma quantidade inteira maior que zero e um preço válido.</p>}
      </section>}
      {erro && <p role="alert" style={{color:"#ff8585", margin:0}}>{erro}</p>}
    </div>
  </CommerceDialog>;
}